module.exports = __webpack_public_path__ + "img/pen-icon-red.c03650a1.svg";